import type { DefineComponent } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { createHead } from '@unhead/vue/client';
import dayjs from 'dayjs';
import de from 'dayjs/locale/de';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';
import '../css/main.css';
import '@unocss/reset/tailwind.css';
import 'uno.css';

const head = createHead();

createInertiaApp({
  resolve: name => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
  setup({ App, el, plugin, props }) {
    return createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue)
      .use(head)
      .mount(el);
  },
});

dayjs.locale(de);
dayjs.extend(weekday);
dayjs.extend(localeData);
